import type { Principal } from '../api/client.js';

/**
 * Returns true iff the principal holds the `tps-admin` role from the Entra JWT
 * `roles` claim. The UI gate is a convenience only — the BFF is authoritative
 * and returns HTTP 403 for non-admins regardless.
 */
export function hasAdminRole(principal: Principal | null | undefined): boolean {
  return (
    !!principal &&
    Array.isArray(principal.roles) &&
    principal.roles.includes('tps-admin')
  );
}
